import React from 'react';
import './Mainloader.css';
import logo from "../../../assets/images/logo.png"

export const Mainloader = () => {
    return (
        <div
            className="fixed h-screen w-screen z-50 shimmer-bg"
        >
            <div className="container flex h-full w-full justify-center flex-col items-center gap-4 pl-10">
                <div className="logo-animate relative">
                    {/* Logo placeholder - replace with your actual logo */}
                    <div className="container flex h-full w-full justify-center items-center">
                        <div className=''>
                            <img src={logo} alt="" className="w-14 h-auto object-cover" />

                        </div>

                    </div>
                </div>

                {/* <div className="flex items-center w-full justify-center gap-2 text-white/90 text-lg font-light tracking-wider">
                    <div className="loading-dots flex gap-1">
                        <span className="w-1.5 h-1.5 bg-purple-400 rounded-full inline-block"></span>
                        <span className="w-1.5 h-1.5 bg-purple-400 rounded-full inline-block"></span>
                        <span className="w-1.5 h-1.5 bg-purple-400 rounded-full inline-block"></span>
                    </div>
                </div> */}
                {/* Pulse ring effect */}
                {/* <div className="absolute inset-0 rounded-lg bg-white opacity-75 animate-ping"></div> */}
            </div>
        </div>

    )
}
